import { render, staticRenderFns } from "./MonetaryAmountFieldset.yaml?vue&type=template&id=456952f9&component"
import script from "./MonetaryAmountFieldset.yaml?vue&type=script&lang=ts&component"
export * from "./MonetaryAmountFieldset.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports